import React, { useState } from 'react';
import { Stack, Chip, Tooltip, Collapse, Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';

export default function PermisosCell ({ permisosArray }) {
  const [expanded, setExpanded] = useState(false);
  
  const permisos = Array.isArray(permisosArray) ? permisosArray : [];
  const limite = 1;
  const tieneMas = permisos.length > limite;

  // Dividimos el array en dos partes
  const iniciales = permisos.slice(0, limite);
  const extra = permisos.slice(limite);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column'}}>
      {/* Contenedor principal para los primeros 5 y el botón */}
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ alignItems: 'center' }}>
        {iniciales.map((p, i) => (
          <Chip 
            icon={<EmojiObjectsOutlinedIcon sx={{scale:'0.95'}}/>}
            key={p.id||i} label={p.nombre} size="meidum" variant="outlined"
            sx={{fontWeight:'bold',bgcolor:'white'}} />
        ))}

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Stack 
            direction="row" 
            spacing={1} 
            flexWrap="wrap" 
            useFlexGap 
          >
            {extra.map((p, i) => (
              <Chip icon={<EmojiObjectsOutlinedIcon sx={{scale:'0.95'}}/>} sx={{fontWeight:'bold',bgcolor:'white'}}  key={p.id||`extra-${i}`} label={p.nombre} variant="outlined" />
            ))}
          </Stack>
        </Collapse>

        {tieneMas && (
          
          <Tooltip title={expanded ? "Ver menos" : "Ver todos"}>
            <Chip 
              label={expanded ? "Ver menos" : `+ ${extra.length}`} 
              onClick={() => setExpanded(!expanded)} 
              variant="outlined" 
              clickable 
              sx={{ 
                px:1, 
                transition: 'all 0.3s ease',
                color:'white',
                bgcolor:'black',
                ":hover":{bgcolor:grey[700]}
              }} 
            />
          </Tooltip>
        )}
      </Stack>
    </Box>
  );
};